import { Chip as MuiChip, styled } from '@mui/material';

export const Chip = styled(MuiChip, {
  shouldForwardProp: (prop) => prop !== 'isSuccess',
})<{ isSuccess?: boolean }>(({ theme, isSuccess = false }) => ({
  backgroundColor: isSuccess ? theme.palette.green.light : theme.palette.accentColor.light,
  color: '#fff',
  fontWeight: 600,
}));
